export default {
  translation: {
    // App
    appName: "Vivre en Santé",
    appSubtitle: "Portail du personnel",

    // Nav
    nav: {
      dashboard: "Tableau de bord",
      staff: "Personnel",
      schedule: "Horaires",
      leaves: "Congés",
      timeclock: "Pointage",
      badges: "Badges",
      patients: "Usagers",
      activities: "Activités",
      activityCatalog: "Catalogue activités",
      transport: "Transport",
      incidents: "Incidents/Accidents",
      centers: "Centres",
      permissions: "Permissions",
      privacyIncidents: "Confidentialité",
      reports: "Rapports",
      settings: "Paramètres",
      logout: "Déconnexion",
    },

    // Auth
    auth: {
      login: "Se connecter",
      logout: "Déconnexion",
      email: "Courriel",
      password: "Mot de passe",
      forgotPassword: "Mot de passe oublié?",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      mustChangePassword: "Vous devez changer votre mot de passe pour continuer.",
      welcomeBack: "Bienvenue",
      loginTitle: "Connexion au portail",
    },

    legal: {
      footerPrivacy: "Confidentialité",
      footerAccessibility: "Accessibilité",
      title: "Confidentialité et renseignements personnels",
      subtitle: "Informations publiées par {{organization}} concernant la protection des renseignements personnels.",
      backToLogin: "Retour à la connexion",
      responsibleHeading: "Responsable de la protection des renseignements personnels",
      policyHeading: "Pratiques de confidentialité",
      policyIntro: "{{organization}} recueille et utilise uniquement les renseignements nécessaires à la gestion du portail, des accès, des services et du suivi clinique ou opérationnel autorisé.",
      contactHeading: "Exercer vos droits ou poser une question",
      contactText: "Pour toute demande d'accès, de rectification, de retrait de consentement lorsque applicable, ou pour signaler un incident de confidentialité, communiquez avec la personne responsable ci-dessous.",
      lastUpdated: "Dernière mise à jour: {{date}}",
      policyItems: {
        collection: "Les renseignements sont collectés pour l'authentification, la gestion des dossiers, la planification, le pointage et les suivis autorisés.",
        use: "L'accès aux renseignements est limité selon les rôles et les besoins liés aux fonctions.",
        access: "Les renseignements peuvent être communiqués à des fournisseurs ou partenaires autorisés seulement lorsque nécessaire au fonctionnement du service et sous encadrement approprié.",
        security: "Des mesures de sécurité administratives, techniques et physiques sont appliquées pour protéger les renseignements personnels.",
        retention: "Les renseignements sont conservés seulement pour la durée nécessaire aux finalités prévues et aux obligations légales applicables.",
        rights: "Toute personne peut demander l'accès ou la rectification de ses renseignements personnels selon les modalités prévues par la loi."
      }
    },

    accessibility: {
      title: "Accessibilité",
      subtitle: "Déclaration d'accessibilité du portail du personnel.",
      skipToContent: "Aller au contenu principal",
      primaryNav: "Navigation principale",
      sidebarNav: "Barre latérale",
      openMenu: "Ouvrir le menu principal",
      closeMenu: "Fermer le menu principal",
      languageSelector: "Sélection de la langue",
      commitment: "Nous nous engageons à améliorer l'accessibilité du portail du personnel pour les personnes ayant des limitations fonctionnelles ou utilisant des technologies d'assistance.",
      measuresTitle: "Mesures en place",
      measure1: "Association explicite des libellés et des champs de formulaire dans les parcours publics.",
      measure2: "Mise à jour automatique de la langue du document selon la langue d'affichage sélectionnée.",
      measure3: "Publication d'un point de contact pour signaler un obstacle d'accessibilité.",
      feedbackTitle: "Signaler un obstacle",
      feedbackText: "Si vous éprouvez une difficulté d'accès, de navigation ou de compréhension sur ce portail, écrivez-nous et nous analyserons la situation."
    },

    // Dashboard
    dashboard: {
      title: "Tableau de bord",
      welcome: "Bonjour",
      overview: "Aperçu du système",
      activeStaff: "Personnel actif",
      activeManagers: "Gestionnaires actifs",
      pendingLeaves: "Congés en attente",
      todayShifts: "Quarts aujourd'hui",
      totalPatients: "Total usagers",
      quickActions: "Actions rapides",
      addStaff: "Ajouter un employé",
      addCenter: "Ajouter un centre",
      viewLeaves: "Voir les congés",
      viewSwaps: "Voir les échanges",
      recentActivity: "Activité récente",
    },

    // Staff
    staff: {
      title: "Gestion du personnel",
      addStaff: "Ajouter un employé",
      editStaff: "Modifier l'employé",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Courriel",
      phone: "Téléphone",
      role: "Rôle",
      center: "Centre",
      employeeNumber: "Numéro d'employé",
      status: "Statut",
      active: "Actif",
      inactive: "Inactif",
      lastLogin: "Dernière connexion",
      searchPlaceholder: "Rechercher un employé...",
      noStaff: "Aucun employé trouvé",
    },

    // Roles
    roles: {
      admin: "Administrateur",
      manager: "Gestionnaire",
      staff: "Personnel",
      usager: "Usager",
      patient: "Usager",
    },

    // Shifts
    shifts: {
      title: "Horaires",
      addShift: "Ajouter un quart",
      editShift: "Modifier le quart",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      assignTo: "Assigner à",
      scheduled: "Planifié",
      completed: "Complété",
      cancelled: "Annulé",
      swapped: "Échangé",
      noShifts: "Aucun quart planifié",
    },

    // Leaves
    leaves: {
      title: "Gestion des congés",
      requestLeave: "Demander un congé",
      startDate: "Date de début",
      endDate: "Date de fin",
      type: "Type de congé",
      reason: "Raison",
      status: "Statut",
      pending: "En attente",
      approved: "Approuvé",
      rejected: "Refusé",
      approve: "Approuver",
      reject: "Refuser",
      reviewNote: "Note du réviseur",
      leaveTypes: {
        vacation: "Vacances",
        sick: "Maladie",
        personal: "Personnel",
        unpaid: "Sans solde",
        other: "Autre",
      },
      noLeaves: "Aucune demande de congé",
    },

    // Time Clock
    timeclock: {
      title: "Pointage",
      clockIn: "Pointer l'entrée",
      clockOut: "Pointer la sortie",
      clockedIn: "Pointé — en service",
      notClockedIn: "Non pointé",
      since: "Depuis",
      hoursWorked: "Heures travaillées",
      history: "Historique",
      date: "Date",
      entry: "Entrée",
      exit: "Sortie",
      duration: "Durée",
      source: "Source",
    },

    badgeScan: {
      badgeKiosk: "Kiosque de badges",
      operatorLogin: "Connexion opérateur dédiée",
      username: "Identifiant",
      password: "Mot de passe",
      openKiosk: "Ouvrir le kiosque",
      connecting: "Connexion...",
      invalidCredentials: "Identifiants du kiosque invalides",
      invalidSession: "Session du kiosque invalide",
      defaultCenter: "Centre",
      welcomeScan: "Bienvenue au {{center}}. Scannez votre badge",
      autoReading: "Lecture automatique active",
      noAuth: "Aucune authentification badge active",
      noAuthHelp: "Connectez le kiosque ou renseignez une clé API en mode test",
      validating: "Validation en cours...",
      welcome: "Bienvenue",
      thanks: "Merci et à la prochaine",
      entrySaved: "Entrée enregistrée",
      exitSaved: "Sortie enregistrée",
      rejectedScan: "Scan rejeté",
      checkBadge: "Vérifiez le badge, l'assignation et l'accès au centre",
      serialError: "Erreur série",
      hidError: "Erreur USB HID",
      nfcError: "Erreur Web NFC",
      nfcNoUid: "UID non disponible via Web NFC",
      nfcReadFailed: "Lecture NFC impossible sur ce tag",
      nfcSecureContextRequired: "Web NFC requiert HTTPS",
      statusScan: "Statut scan",
      waitingBadge: "En attente de badge...",
      configMode: "Configuration / mode test",
      apiKey: "Clé API badge",
      centerName: "Nom du centre",
      logoUrl: "Logo (URL)",
      deviceId: "ID appareil",
      sourceSystem: "Système source",
      serialBaud: "Débit en bauds série",
      connectSerial: "Connecter le port série USB",
      disconnectSerial: "Déconnecter le port série",
      connectHid: "Connecter l'appareil USB HID",
      disconnectHid: "Déconnecter l'appareil USB HID",
      connectWebNfc: "Activer Web NFC",
      disconnectWebNfc: "Désactiver Web NFC",
      connected: "Connecté",
      disconnected: "Déconnecté",
      notSupported: "Non pris en charge",
      serial: "Série",
      hid: "USB HID",
      webNfc: "Web NFC",
      keyboardScanner: "Scanner clavier: actif (champ focus)",
      wedgePlaceholder: "Scanner clavier/wedge: badge puis Entrée",
      validateScan: "Valider scan",
      presentBadge: "Présentez votre badge",
      autoInOut: "Entrée / sortie détectées automatiquement par le backend",
      localKiosk: "Kiosque de badges local",
      socketLocal: "Bridge local",
      socketUrl: "URL bridge",
      hideConfig: "Masquer config",
      showConfig: "Config / mode test",
      lock: "Verrouiller",
      timezone: "Timezone ET (America/Toronto)",
      unknownUser: "Usager",
      eventLabel: "Événement",
    },

    // Usagers
    patients: {
      title: "Dossiers usagers",
      addPatient: "Ajouter un usager",
      editRecord: "Modifier le dossier",
      dateOfBirth: "Date de naissance",
      gender: "Genre",
      healthCard: "No. carte santé",
      bloodType: "Groupe sanguin",
      allergies: "Allergies",
      medications: "Médicaments actuels",
      conditions: "Conditions médicales",
      insurance: "Assurance",
      insuranceNumber: "No. assurance",
      emergencyContact: "Contact d'urgence",
      emergencyPhone: "Tél. urgence",
      admissionDate: "Date d'admission",
      notes: "Notes",
      noPatients: "Aucun usager trouvé",
    },

    // Centers
    centers: {
      title: "Gestion des centres",
      addCenter: "Ajouter un centre",
      editCenter: "Modifier le centre",
      name: "Nom du centre",
      address: "Adresse",
      phone: "Téléphone",
      email: "Courriel",
      staffCount: "Nombre de personnel",
      noCenters: "Aucun centre trouvé",
    },

    // Reports
    reports: {
      title: "Rapports",
      timesheets: "Rapport de Pointage",
      workHours: "Heures travaillées",
      payroll: "Paie",
      coverage: "Couverture des centres",
      generate: "Générer",
      export: "Exporter CSV",
      startDate: "Date de début",
      endDate: "Date de fin",
      totalHours: "Total heures",
      employee: "Employé",
      kpi: {
        title: "KPI Usagers",
        socializationRate: "Taux de socialisation",
        autonomyProgressRate: "Progression autonomie",
        familySatisfactionRate: "Satisfaction proches aidants",
        fallsCount: "Nombre de chutes",
        activityParticipationRate: "Participation activités",
        activityFrequencyPerPatient: "Fréquence activités / usager",
        hospitalizationReductionRate: "Réduction hospitalisation",
        careFollowupRate: "Suivi des soins",
        mealSatisfactionRate: "Satisfaction repas",
        presenceRate: "Taux de présence",
        patientTableTitle: "KPI par usager",
      },
    },

    // Common
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      view: "Voir",
      close: "Fermer",
      expand: "Agrandir",
      reduce: "Réduire",
      expandWindow: "Agrandir la fenêtre",
      reduceWindow: "Réduire la fenêtre",
      confirm: "Confirmer",
      search: "Rechercher",
      filter: "Filtrer",
      all: "Tous",
      yes: "Oui",
      no: "Non",
      loading: "Chargement...",
      error: "Une erreur est survenue",
      success: "Succès",
      noData: "Aucune donnée",
      required: "Champ requis",
      actions: "Actions",
      createdAt: "Créé le",
      updatedAt: "Modifié le",
      page: "Page",
      of: "de",
      perPage: "par page",
    },
  },
};
